import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import SectionHeader from "../components/common/sectionHeader";
import ProjectCard from "../components/projects/projectCard";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const categories = ["All", "Featured", "Java & Spring", "React & Node", "Python & AI"];

const Projects = () => {
	const [activeFilter, setActiveFilter] = useState("All");

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects") || SEO[3];

	const filteredProjects = INFO.projects.filter((p) => {
		if (activeFilter === "Featured") return p.featured;
		if (activeFilter === "Java & Spring") return p.tech.some(t => t.includes("Java") || t.includes("Spring"));
		if (activeFilter === "React & Node") return p.tech.some(t => t.includes("React") || t.includes("Node") || t.includes("MongoDB"));
		if (activeFilter === "Python & AI") return p.tech.some(t => t.includes("Python") || t.includes("OpenCV") || t.includes("YOLOv5"));
		return true;
	});

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.name}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta name="keywords" content={currentSEO.keywords.join(", ")} />
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />

				<main className="content-wrapper">
					<div className="projects-page-container">
						<SectionHeader
							tag="Engineering Portfolio"
							title="Products & Software"
							highlight="Applications Built"
							subtitle="End-to-end full-stack applications, transactional backend services, and computer vision systems."
						/>

						<div className="projects-filter-bar">
							{categories.map((cat, idx) => (
								<button
									key={idx}
									className={`filter-btn ${activeFilter === cat ? "active" : ""}`}
									onClick={() => setActiveFilter(cat)}
								>
									{cat}
								</button>
							))}
						</div>

						<div className="all-projects-grid">
							{filteredProjects.map((project, idx) => (
								<ProjectCard key={project.id || idx} project={project} index={idx} />
							))}
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</main>
			</div>
		</React.Fragment>
	);
};

export default Projects;
